import { createContext, useContext } from "react";
import type { MeResponse } from "@shared/types";

export interface AuthValue {
  user: MeResponse;
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthValue | null>(null);

export function useAuth(): AuthValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthContext.Provider>");
  return ctx;
}
